import type { Action, PermissionEntry, Resource } from '@repo/constants'

export const hasPermission = (
  permissions: PermissionEntry[] | null,
  resource: Resource,
  action: Action,
) => (permissions ?? []).some((p) => p.resource === resource && p.action === action)
